function  Statistic() {

    let statisticContent = [
        {
            number: 50,
            text: 'спікерок'
        },
        {
            number: 300,
            text: 'учасниць'
        },
        {
            number: 8,
            text: 'годин контенту'
        },
        {
            number: 'жіноча',
            text: 'спільнота'
        }
    ]

    return (
        <section className="relative bg-[#245864]">
            <div className="container max-w-screen-xl mx-auto relative z-30 overflow-hidden px-[15px]">
                <div className="grid grid-cols-2 py-12 gap-8 md:flex xl:px-14">
                    {
                        statisticContent?.map((item, index) => {
                            return (
                                <div className="text-white flex flex-col items-center md:flex-1 lg:flex-row lg:gap-5" key={index}>
                                    <span className="font-medium text-[40px] leading-none lg:text-6xl">{item.number}</span>
                                    <span>{item.text}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default Statistic;